const WISHLIST_KEY = 'koji_wishlist_data';
const KOJI_WISH_CARD_CACHE = {};
const KOJI_WISH_PRICE = {}; // handle -> prezzo aggiornato in euro, letto dalla card del tema
let kojiWishRenderToken = 0;

/* Lettura sicura dei preferiti salvati nel browser: se il contenuto è rovinato o manomesso si riparte da una lista vuota */
function kojiWishRead() {
    let raw = [];
    try { raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { raw = []; }
    if (!Array.isArray(raw)) return [];
    return raw.filter(item => item && typeof item === 'object' && typeof item.handle === 'string' && item.handle.length > 0 && item.handle.length < 200);
}

/* Le immagini dei preferiti devono essere indirizzi https */
function kojiWishSafeImage(u) {
    try {
        const url = new URL(String(u || ''), window.location.origin);
        return url.protocol === 'https:' ? url.href : '';
    } catch (e) {
        return '';
    }
}

/* Stile della griglia con le card condivise */
(function () {
    const css = '.koji-wishlist-grid .koji-col-item{min-width:0}' +
        '.koji-wishlist-grid .koji-col-item>.shopify-section{height:100%}' +
        '.koji-wishlist-grid .koji-col-item .kcard{height:100%}' +
        '.koji-wish-skeleton{aspect-ratio:3/4.6;border-radius:20px;background:linear-gradient(110deg,rgba(255,255,255,.04) 30%,rgba(255,255,255,.09) 50%,rgba(255,255,255,.04) 70%);background-size:200% 100%;animation:kojiWishShimmer 1.4s linear infinite}' +
        '@keyframes kojiWishShimmer{to{background-position:-200% 0}}';
    const el = document.createElement('style');
    el.setAttribute('data-koji-wish', '');
    el.textContent = css;
    document.head.appendChild(el);
})();

document.addEventListener('DOMContentLoaded', () => {
    initWishlist();
});

/* Cuore sulle card prodotto: i dati arrivano dagli attributi data-* del pulsante (nessun codice dentro il markup).
   Se esiste già toggleProductWishlistItem (definita dalla pagina di ricerca) si usa quella, altrimenti la versione qui sotto. */
document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest ? e.target.closest('.koji-card-wishlist-btn[data-handle]') : null;
    if (!btn) return;
    if (btn.hasAttribute('onclick')) return; // markup vecchio con onclick: ci pensa lui
    if (e.defaultPrevented) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-handle') || '';
    const title = btn.getAttribute('data-title') || '';
    const price = btn.getAttribute('data-price') || '';
    const image = btn.getAttribute('data-image') || '';
    if (!handle) return;
    if (typeof window.toggleProductWishlistItem === 'function') {
        window.toggleProductWishlistItem(handle, title, price, image, btn);
    } else {
        kojiToggleCardHeart(handle, title, price, image, btn);
    }
});

function kojiToggleCardHeart(handle, title, price, image, btn) {
    toggleWishlistItem(handle, title, price, image);
    const on = kojiWishRead().some(item => item.handle === handle);
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
}

function initWishlist() {
    updateWishlistUI();
    const wishlistGrid = document.getElementById('koji-wishlist-grid');
    if (wishlistGrid) {
        // Il cuore dentro la card condivisa, qui, toglie il prodotto dai preferiti
        wishlistGrid.addEventListener('click', (e) => {
            const heart = e.target.closest('.koji-card-wishlist-btn, .koji-wishlist-btn');
            if (!heart || !wishlistGrid.contains(heart)) return;
            e.preventDefault();
            e.stopPropagation();
            const handle = heart.dataset.handle;
            if (handle) removeWithAnimation(handle, heart);
        }, true);
        renderWishlistPage();
    }
}

function setupWishlistButtons() {
    updateWishlistUI(); 
}

window.removeWithAnimation = function(handle, btnEl) {
    const colItem = btnEl.closest('.koji-col-item');
    if (colItem) {
        colItem.classList.add('is-removing');
        setTimeout(() => {
            toggleWishlistItem(handle);
        }, 300);
    } else {
        toggleWishlistItem(handle);
    }
}

function toggleWishlistItem(handle, title, price, image) {
    let wishlist = kojiWishRead();
    const index = wishlist.findIndex(item => item.handle === handle);

    if (index > -1) {
        wishlist.splice(index, 1);
    } else {
        wishlist.push({ handle, title, price, image });
        if (navigator.vibrate) navigator.vibrate([20, 50, 20]);
    }

    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist)); } catch (e) {}
    updateWishlistUI();
    
    if (document.getElementById('koji-wishlist-grid')) {
        renderWishlistPage();
    }
}

function updateWishlistUI() {
    const wishlist = kojiWishRead();
    const count = wishlist.length;
    
    const badges = document.querySelectorAll('.koji-wishlist-badge');
    badges.forEach(badge => {
        badge.textContent = count;
        badge.classList.toggle('is-active', count > 0);
    });

    document.querySelectorAll('.koji-wishlist-btn').forEach(btn => {
        const handle = btn.dataset.handle;
        const isActive = wishlist.some(item => item.handle === handle);
        btn.classList.toggle('is-active', isActive);
    });
    
    const container = document.getElementById('koji-wish-data-provider');
    if(container) {
        let glow = 0;
        if (count >= 10) glow = 1;
        else if (count >= 5) glow = 0.6;
        else if (count > 0) glow = 0.25;
        container.style.setProperty('--glow-intensity', glow);
    }
}

function getKojiReaction(count) {
    const provider = document.getElementById('koji-wish-data-provider');
    if (!provider) return "...";

    if (count === 0) return provider.getAttribute('data-r0');
    if (count === 1) return provider.getAttribute('data-r1');
    if (count > 1 && count <= 4) return provider.getAttribute('data-rfew');
    if (count > 4 && count <= 9) return provider.getAttribute('data-rmany');
    if (count >= 10) return provider.getAttribute('data-repic').replace('{count}', count);
}

function parsePriceToNumber(priceString) {
    if (!priceString) return 0;
    let cleaned = String(priceString).replace(/[^0-9,-]+/g,"");
    cleaned = cleaned.replace(',', '.');
    const val = parseFloat(cleaned);
    return isNaN(val) ? 0 : val;
}

function escapeWishHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

/* Card di riserva: usata solo se la card del tema non si riesce a caricare
   (prodotto eliminato o archiviato, rete assente). */
function fallbackWishCard(item) {
    const t = escapeWishHtml(item.title);
    const h = escapeWishHtml(encodeURIComponent(item.handle));
    const hAttr = escapeWishHtml(item.handle);
    return `
        <div class="koji-card">
            <div class="koji-card-img-wrap aspect-portrait-3-4">
                <button type="button" class="koji-wishlist-btn is-active" data-handle="${hAttr}" aria-label="Rimuovi dai desideri">
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
                </button>
                <a href="/products/${h}" class="koji-card-img-link" aria-label="Vedi ${t}">
                    <img src="${escapeWishHtml(kojiWishSafeImage(item.image))}" class="koji-card-img" loading="lazy" alt="${t}">
                </a>
            </div>
            <div class="koji-card-info-area">
                <a href="/products/${h}" class="koji-card-info" aria-label="Vedi ${t}">
                    <h3 class="koji-card-title">${t}</h3>
                    <div class="koji-card-price-row">
                        <span class="koji-card-price">${escapeWishHtml(item.price)}</span>
                    </div>
                </a>
            </div>
        </div>`;
}

/* Scarica la card vera del tema (Section Rendering API), con cache per la sessione della pagina */
function loadWishCard(item) {
    const handle = item.handle;
    if (KOJI_WISH_CARD_CACHE[handle]) return Promise.resolve(KOJI_WISH_CARD_CACHE[handle]);
    return fetch(`/products/${encodeURIComponent(handle)}?section_id=koji-wishlist-card`, { headers: { 'Accept': 'text/html' } })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(html => {
            if (html.indexOf('kcard') === -1 && html.indexOf('koji-card') === -1) throw new Error('card assente');
            KOJI_WISH_CARD_CACHE[handle] = html;
            const m = html.match(/data-wl-price="(\d+)"/);
            if (m) KOJI_WISH_PRICE[handle] = parseInt(m[1], 10) / 100;
            return html;
        })
        .catch(() => null);
}

/* Totale: prezzo aggiornato dalla card del tema; finche' non e' arrivato (o se il prodotto non c'e' piu') vale il prezzo salvato col cuore */
function updateWishlistTotal() {
    const totalText = document.getElementById('koji-wish-total');
    if (!totalText) return;
    const wishlist = kojiWishRead();
    let totalValue = 0;
    wishlist.forEach(item => {
        totalValue += (typeof KOJI_WISH_PRICE[item.handle] === 'number')
            ? KOJI_WISH_PRICE[item.handle]
            : parsePriceToNumber(item.price);
    });
    totalText.textContent = '€' + totalValue.toFixed(2).replace('.', ',');
}

function syncWishHearts(root) {
    root.querySelectorAll('.koji-card-wishlist-btn, .koji-wishlist-btn').forEach(btn => {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Rimuovi dai desideri');
        btn.removeAttribute('onclick');
    });
}

function renderWishlistPage() {
    const container = document.getElementById('koji-wishlist-grid');
    const wrapArea = document.getElementById('koji-wish-stats-actions-wrap');
    const statsArea = document.getElementById('koji-wish-stats');
    const actionsArea = document.getElementById('koji-wish-actions');
    const reactionText = document.getElementById('koji-wishlist-reaction');
    const countText = document.getElementById('koji-wish-count');
    const provider = document.getElementById('koji-wish-data-provider');
    
    if (!container || !provider) return;

    const wishlist = kojiWishRead();
    const token = ++kojiWishRenderToken;
    
    if(reactionText) reactionText.textContent = getKojiReaction(wishlist.length);

    if (wishlist.length === 0) {
        container.innerHTML = `
            <div class="koji-wish-empty-state">
                <div class="koji-wish-empty-icon">${provider.getAttribute('data-e-icon')}</div>
                <h2>${provider.getAttribute('data-e-title')}</h2>
                <p>${provider.getAttribute('data-e-desc')}</p>
                <a href="${provider.getAttribute('data-e-link')}" class="koji-btn-primary" style="margin-top: 10px;">${provider.getAttribute('data-e-btn')}</a>
            </div>`;
        if(wrapArea) wrapArea.style.display = 'none';
        return;
    }

    if(countText) countText.textContent = wishlist.length;
    updateWishlistTotal();

    if(wrapArea) wrapArea.style.display = 'flex';
    if(actionsArea) actionsArea.style.display = 'flex';
    if(statsArea) statsArea.style.display = 'flex';

    // Scheletro immediato (o card gia' in cache), poi si riempie con la card del tema
    container.innerHTML = wishlist.map(item => {
        const cached = KOJI_WISH_CARD_CACHE[item.handle];
        return `<div class="koji-col-item${cached ? '' : ' is-loading'}" data-handle="${escapeWishHtml(item.handle)}" style="width: 100%; flex: none;">${cached || '<div class="koji-wish-skeleton" aria-hidden="true"></div>'}</div>`;
    }).join('');
    syncWishHearts(container);

    wishlist.forEach(item => {
        if (KOJI_WISH_CARD_CACHE[item.handle]) return;
        loadWishCard(item).then(html => {
            if (token !== kojiWishRenderToken) return;
            const slot = Array.prototype.find.call(container.children, el => el.getAttribute('data-handle') === item.handle);
            if (!slot) return;
            slot.classList.remove('is-loading');
            slot.innerHTML = html || fallbackWishCard(item);
            syncWishHearts(slot);
            updateWishlistTotal();
        });
    });
}

async function moveWishlistToCart() {
    const btn = document.getElementById('koji-wishlist-add-all');
    const originalText = btn.querySelector('span').textContent;
    btn.querySelector('span').textContent = "Evocazione... ⏳";
    btn.style.pointerEvents = 'none';
    btn.style.filter = 'brightness(0.7)';

    if (navigator.vibrate) navigator.vibrate(100);

    const wishlist = kojiWishRead();
    
    try {
        for (const item of wishlist) {
            let variantId = await getVariantId(item.handle);
            if(variantId) {
                 let formData = { 'items': [{ 'id': variantId, 'quantity': 1 }] };
                 await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) });
            }
        }
        window.dispatchEvent(new Event('cart:updated'));
        window.location.href = '/cart';
    } catch(err) {
        console.error("Errore durante l'aggiunta al carrello", err);
        btn.querySelector('span').textContent = "Errore. Riprova.";
        setTimeout(() => { 
            btn.querySelector('span').textContent = originalText; 
            btn.style.pointerEvents = 'auto'; 
            btn.style.filter = 'none'; 
        }, 2000);
    }
}

async function getVariantId(handle) {
    try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        const data = await res.json();
        return data.variants[0].id;
    } catch (e) {
        console.error('Non riesco a trovare la variante per', handle);
        return null;
    }
}